"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Savvy = void 0;

var Column = /*#__PURE__*/function () {
  function Column(parent, key, nulls) {
    _classCallCheck(this, Column);

    this.parent = parent;
    this.key = key;
    this.nulls = nulls;
  }

  _createClass(Column, [{
    key: "raw",
    value: function raw() {
      var _this = this;

      return new Array(this.parent.n).fill(0).map(function (_, idx) {
        return _this.parent.cell(idx, _this.key, false);
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return true;
    }
  }, {
    key: "ismissing",
    value: function ismissing(value) {
      return this.nulls.has(value);
    }
  }, {
    key: "values",
    get: function get() {
      var _this2 = this;

      return this.raw().map(function (value) {
        return _this2.cast(value);
      });
    }
  }, {
    key: "name",
    get: function get() {
      var _a;

      return (_a = this.parent.names.get(this.key)) !== null && _a !== void 0 ? _a : this.key;
    }
  }, {
    key: "label",
    get: function get() {
      var _a;

      return (_a = this.parent.labels.get(this.key)) !== null && _a !== void 0 ? _a : '';
    }
  }, {
    key: "missing",
    get: function get() {
      return new Set(this.nulls);
    },
    set: function set(nulls) {
      this.nulls = new Set(nulls);
    }
  }]);

  return Column;
}();

var NullColumn = /*#__PURE__*/function (_Column) {
  _inherits(NullColumn, _Column);

  var _super = _createSuper(NullColumn);

  function NullColumn(parent) {
    _classCallCheck(this, NullColumn);

    return _super.call(this, parent, '<NULL>', new Set());
  }

  _createClass(NullColumn, [{
    key: "exists",
    value: function exists() {
      return false;
    }
  }, {
    key: "raw",
    value: function raw() {
      return new Array(this.parent.n).fill(null);
    }
  }, {
    key: "cast",
    value: function cast(value) {
      return null;
    }
  }, {
    key: "values",
    get: function get() {
      return new Array(this.parent.n).fill(null);
    }
  }, {
    key: "measure",
    get: function get() {
      return 'null';
    }
  }, {
    key: "levels",
    get: function get() {
      return new Map();
    }
  }]);

  return NullColumn;
}(Column);

var StrColumn = /*#__PURE__*/function (_Column2) {
  _inherits(StrColumn, _Column2);

  var _super2 = _createSuper(StrColumn);

  function StrColumn() {
    _classCallCheck(this, StrColumn);

    return _super2.apply(this, arguments);
  }

  _createClass(StrColumn, [{
    key: "cast",
    value: function cast(value) {
      return this.ismissing(value) ? null : value;
    }
  }, {
    key: "measure",
    get: function get() {
      return 'nominal';
    }
  }, {
    key: "levels",
    get: function get() {
      return new Map();
    }
  }]);

  return StrColumn;
}(Column);

var FacColumn = /*#__PURE__*/function (_Column3) {
  _inherits(FacColumn, _Column3);

  var _super3 = _createSuper(FacColumn);

  function FacColumn(parent, key, levels, nulls, type) {
    var _this3;

    _classCallCheck(this, FacColumn);

    _this3 = _super3.call(this, parent, key, nulls);
    _this3._levels = levels;
    _this3.type = type;
    return _this3;
  }

  _createClass(FacColumn, [{
    key: "cast",
    value: function cast(value) {
      return this.ismissing(value) ? null : this._levels.get(value);
    }
  }, {
    key: "measure",
    get: function get() {
      switch (this.type) {
        case 3:
          return 'scale';

        case 2:
          return 'ordinal';

        default:
          return 'nominal';
      }
    }
  }, {
    key: "levels",
    get: function get() {
      return new Map(_toConsumableArray(this._levels));
    },
    set: function set(levels) {
      var _this4 = this;

      levels.forEach(function (value, key) {
        if (_this4._levels.has(key)) {
          _this4._levels.set(key, value);
        }
      });
    }
  }]);

  return FacColumn;
}(Column);

var NumColumn = /*#__PURE__*/function (_Column4) {
  _inherits(NumColumn, _Column4);

  var _super4 = _createSuper(NumColumn);

  function NumColumn(parent, key, nulls, nullrange, type) {
    var _this5;

    _classCallCheck(this, NumColumn);

    _this5 = _super4.call(this, parent, key, nulls);
    _this5.nullrange = nullrange;
    _this5.type = type;
    return _this5;
  }

  _createClass(NumColumn, [{
    key: "cast",
    value: function cast(value) {
      return this.ismissing(value) ? null : value;
    }
  }, {
    key: "ismissing",
    value: function ismissing(value) {
      return this.nulls.has(value) || value > this.nullrange[0] && value < this.nullrange[1];
    }
  }, {
    key: "measure",
    get: function get() {
      switch (this.type) {
        case 2:
          return 'ordinal';

        default:
          return 'scale';
      }
    }
  }, {
    key: "levels",
    get: function get() {
      return new Map();
    }
  }]);

  return NumColumn;
}(Column);

var View = /*#__PURE__*/function () {
  function View(parent, indices, keys) {
    _classCallCheck(this, View);

    var _a, _b;

    this.parent = parent;
    this.indices = (_a = indices === null || indices === void 0 ? void 0 : indices.slice()) !== null && _a !== void 0 ? _a : new Array(parent.n).fill(0).map(function (_, idx) {
      return idx;
    });
    this._keys = (_b = keys === null || keys === void 0 ? void 0 : keys.slice()) !== null && _b !== void 0 ? _b : Array.from(parent.names.keys());
  }

  _createClass(View, [{
    key: "row",
    value: function row(index) {
      return this.parent.row(this.indices[index]);
    }
  }, {
    key: "col",
    value: function col(key) {
      var all = this.parent.col(key);
      return this.indices.map(function (index) {
        return all[index];
      });
    }
  }, {
    key: "cell",
    value: function cell(index, key) {
      return this.parent.cell(this.indices[index], key);
    }
  }, {
    key: "view",
    value: function view(indices, keys) {
      var _this6 = this;

      return new View(this.parent, indices.map(function (index) {
        return _this6.indices[index];
      }), keys);
    }
  }, {
    key: "n",
    get: function get() {
      return this.indices.length;
    }
  }, {
    key: "keys",
    get: function get() {
      return _toConsumableArray(this._keys);
    }
  }, {
    key: "names",
    get: function get() {
      var names = this.parent.names;
      return new Map(this.keys.map(function (key) {
        var _a;

        return [key, (_a = names.get(key)) !== null && _a !== void 0 ? _a : key];
      }));
    }
  }, {
    key: "labels",
    get: function get() {
      var labels = this.parent.labels;
      return new Map(this.keys.map(function (key) {
        var _a;

        return [key, (_a = labels.get(key)) !== null && _a !== void 0 ? _a : ''];
      }));
    }
  }]);

  return View;
}();
/**
 * A DataSet subclass that can be constructed from a {@link Parsed} object
 */


var Savvy = /*#__PURE__*/function () {
  /**
   *
   * @param parsed a {@link Parsed} object generated with a {@link SavParser}
   */
  function Savvy(parsed) {
    _classCallCheck(this, Savvy);

    var _a;

    this.cases = parsed.meta.cases;
    this._names = parsed.internal.names;
    this.data = parsed.rows;
    var levels = new Map(parsed.headers.map(function (header) {
      return [header.name, new Map()];
    }));
    var cursor = 0;
    var indexmap = new Map(parsed.headers.map(function (header, idx) {
      var offset = cursor + 1;
      cursor++;
      cursor += header.trailers;
      return [offset, idx];
    }));
    parsed.internal.levels.forEach(function (entry) {
      return entry.indices.forEach(function (index) {
        return indexmap.has(index) && levels.set(parsed.headers[indexmap.get(index)].name, entry.map);
      });
    });
    this.fields = new Map();
    this.overflows = new Map();
    this._labels = new Map();
    var j = 0;

    for (var i = 0; i < parsed.headers.length; i++) {
      j = i;
      var header = parsed.headers[i];

      this._labels.set(header.name, header.label);

      if (header.code) {
        var overflow = [];

        if (parsed.internal.longs.has(header.name)) {
          var segs = Math.floor(parsed.internal.longs.get(header.name) / 252);

          while (segs > 0) {
            segs -= 1;
            overflow.push(parsed.headers[++i].name);
          }
        }

        this.overflows.set(header.name, overflow);
        this.fields.set(header.name, new StrColumn(this, header.name, new Set(header.missing.strings)));
      } else {
        if ((_a = levels.get(header.name)) === null || _a === void 0 ? void 0 : _a.size) {
          this.fields.set(header.name, new FacColumn(this, header.name, levels.get(header.name), new Set(header.missing.codes), parsed.internal.display[j].type));
        } else {
          this.fields.set(header.name, new NumColumn(this, header.name, new Set(header.missing.codes), header.missing.range, parsed.internal.display[j].type));
        }
      }
    }
  }

  _createClass(Savvy, [{
    key: "row",
    value: function row(index) {
      var _this7 = this;

      var cast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var row = new Map();
      this.keys.forEach(function (key) {
        return row.set(key, _this7.cell(index, key, cast));
      });
      return row;
    }
  }, {
    key: "field",
    value: function field(key) {
      var _a;

      return (_a = this.fields.get(key)) !== null && _a !== void 0 ? _a : new NullColumn(this);
    }
  }, {
    key: "col",
    value: function col(key) {
      var _this8 = this;

      var cast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return new Array(this.n).fill(0).map(function (_, idx) {
        return _this8.cell(idx, key, cast);
      });
    }
  }, {
    key: "cell",
    value: function cell(index, key) {
      var cast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _a;

      var field = this.field(key);
      var row = this.data[index];
      var raw = row.get(key);
      (_a = this.overflows.get(key)) === null || _a === void 0 ? void 0 : _a.forEach(function (overflow) {
        var _a;

        raw = raw.toString() + ((_a = row.get(overflow)) !== null && _a !== void 0 ? _a : '');
      });
      return cast ? field.cast(raw) : raw;
    }
  }, {
    key: "view",
    value: function view(indices, fields) {
      return new View(this, indices, fields);
    }
  }, {
    key: "n",
    get: function get() {
      return this.cases;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.fields.keys());
    }
    /**
     * A map of of unique column keys to variable names
     */

  }, {
    key: "names",
    get: function get() {
      return new Map(_toConsumableArray(this._names));
    },
    set: function set(names) {
      var _this9 = this;

      names.forEach(function (value, key) {
        if (_this9._names.has(key)) {
          _this9._names.set(key, value);
        }
      });
    }
    /**
     * A map of of unique column keys to longer labels
     */

  }, {
    key: "labels",
    get: function get() {
      return new Map(_toConsumableArray(this._labels));
    },
    set: function set(labels) {
      var _this10 = this;

      labels.forEach(function (value, key) {
        if (_this10._labels.has(key)) {
          _this10._labels.set(key, value);
        }
      });
    }
  }]);

  return Savvy;
}();

exports.Savvy = Savvy;